import { APP_ROUTES, DEFAULT_AUTHENTICATED_ROUTE } from "@/constants/app-routes";

/**
 * The route a freshly-authenticated user should land on: the main app if they
 * have finished onboarding, otherwise the onboarding entry (`ONBOARDING_START`,
 * currently the first step while the `/get-started` intro is disabled).
 *
 * Auth flows must navigate here directly rather than pushing
 * `DEFAULT_AUTHENTICATED_ROUTE` and letting the global AuthRouteGuard bounce an
 * un-onboarded user off `/overview`. On the login path the user's cache is
 * seeded synchronously, so that bounce races the login screen's own push and
 * leaves the IonRouterOutlet on a blank view. Deciding the destination up front
 * keeps it a single, clean navigation.
 *
 * Mirrors the guard's `isOnboardingCompleted === true` completion check so the
 * two agree on shape.
 */
export const resolvePostAuthRoute = (isOnboardingCompleted: boolean | undefined): string =>
  isOnboardingCompleted === true ? DEFAULT_AUTHENTICATED_ROUTE : APP_ROUTES.ONBOARDING_START;
